import { render, staticRenderFns } from "./FollowSymbol.vue?vue&type=template&id=14012451&scoped=true"
import script from "./FollowSymbol.vue?vue&type=script&lang=js"
export * from "./FollowSymbol.vue?vue&type=script&lang=js"
import style0 from "./FollowSymbol.vue?vue&type=style&index=0&id=14012451&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14012451",
  null
  
)

export default component.exports